module.exports = __webpack_public_path__ + "static/media/hsse-maersk-inland-services.cf60226c.svg";